const defaultIgnoreSeconds = 30

const getSavedIgnoreSeconds = () => {
  const seconds = parseInt(localStorage.getItem('alertInfoIgnoreSeconds'))
  return Number.isFinite(seconds) && seconds > 0 ? seconds : defaultIgnoreSeconds
}

export const createAlertNotificationState = () => ({
  alertInfoMuteUntil: parseInt(localStorage.getItem('alertInfoMuteUntil')) || 0,
  alertInfoIgnoreDuration: getSavedIgnoreSeconds() * 1000,
  lastAlertInfoNotifyTime: 0,
  alertInfoNotificationVisible: false
})

export const beginAlertNotification = state => {
  const now = Date.now()
  if (state.alertInfoNotificationVisible) return false
  if (now - state.lastAlertInfoNotifyTime < state.alertInfoIgnoreDuration) return false
  if (now < state.alertInfoMuteUntil) return false

  state.lastAlertInfoNotifyTime = now
  state.alertInfoNotificationVisible = true
  return true
}

export const closeAlertNotification = state => {
  state.alertInfoNotificationVisible = false
}

export const muteAlertNotification = (state, seconds) => {
  const selectedSeconds = Number(seconds)
  const fallbackSeconds = Math.max(1, Math.floor(state.alertInfoIgnoreDuration / 1000))
  const muteSeconds = Number.isFinite(selectedSeconds) && selectedSeconds > 0
    ? selectedSeconds
    : fallbackSeconds

  state.alertInfoIgnoreDuration = muteSeconds * 1000
  state.alertInfoMuteUntil = Date.now() + state.alertInfoIgnoreDuration
  state.alertInfoNotificationVisible = false
  localStorage.setItem('alertInfoIgnoreSeconds', String(muteSeconds))
  localStorage.setItem('alertInfoMuteUntil', String(state.alertInfoMuteUntil))
}
